// GanttSearch.jsx
import React, { useState } from 'react';
import { Search, X, Archive, Clock } from 'lucide-react';
import styles from './GanttChartAll.module.css'; // lub własny plik CSS/Module

const GanttSearch = ({ onSearch, onClear, onModeChange }) => {
  const [nr, setNr] = useState('');
  const [rok, setRok] = useState(new Date().getFullYear().toString());
  const [mode, setMode] = useState('current'); // 'current' | 'archive'

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    if (!nr.trim()) return;

    onSearch({
      nr: nr.trim(),
      rok: rok.trim(),
      mode
    });
  };

  const handleClear = () => {
    setNr('');
    onClear();
  };

  const handleModeToggle = (newMode) => {
    setMode(newMode);
    onModeChange?.(newMode);
    // Jeśli wyszukiwanie jest już aktywne, uruchamiamy ponownie dla nowego trybu
    if (nr.trim()) {
      onSearch({
        nr: nr.trim(),
        rok: rok.trim(),
        mode: newMode
      });
    }
  };

  return (
    <form onSubmit={handleSearchSubmit} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {/* Przełącznik Bieżące / Archiwum */}
      <div style={{ display: 'inline-flex', background: '#636363', borderRadius: '6px', padding: '2px' }}>
        <button
          type="button"
          onClick={() => handleModeToggle('current')}
          style={{
            padding: '4px 8px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: mode === 'current' ? '#8abe11' : 'transparent',
            color: '#fff',
            fontSize: '12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}
          title="Szukaj w bieżącym wykresie"
        >
          <Clock size={14} /> Bieżące
        </button>
        <button
          type="button"
          onClick={() => handleModeToggle('archive')}
          style={{
            padding: '4px 8px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: mode === 'archive' ? '#ff9800' : 'transparent',
            color: '#fff',
            fontSize: '12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}
          title="Szukaj w archiwum (API)"
        >
          <Archive size={14} /> Archiwum
        </button>
      </div>

      {/* Inputy: Numer i Rok */}
      <input
        type="text"
        placeholder="Nr zam."
        value={nr}
        onChange={(e) => setNr(e.target.value)}
        style={{
          width: '70px',
          padding: '4px 8px',
          borderRadius: '4px',
          border: '1px solid #636363',
          background: '#636363',
          color: '#fff',
          fontSize: '13px'
        }}
      />
      
      <input
        type="text"
        placeholder="Rok"
        value={rok}
        onChange={(e) => setRok(e.target.value)}
        style={{
          width: '55px',
          padding: '4px 8px',
          borderRadius: '4px',
          border: '1px solid #636363',
          background: '#636363',
          color: '#fff',
          fontSize: '13px'
        }}
      />

      <button
        type="submit"
        style={{
          padding: '5px 10px',
          backgroundColor: '#a9ce54',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          height:'30px'
        }}
        title="Szukaj"
      >
        <Search size={16} />
      </button>

      {/* {nr && (
        <button
          type="button"
          onClick={handleClear}
          style={{
            padding: '5px',
            backgroundColor: '#ff4d4f',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
          title="Wyczyść szukanie"
        >
          <X size={16} />
        </button>
      )} */}
    </form>
  );
};

export default React.memo(GanttSearch);